<template>
  <div v-if="message" class="mt-4 mb-8">
    <p class="py-3 rounded-sm bg-green-400 text-white text-sm">
      {{ message }}
    </p>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  props: {
    next: { type: String, default: null },
  },
  setup(props, { root }) {
    const message = computed(() => {
      return {
        IS_REGISTERED_ORGANIZER:
          'Your e-mail address is already registered. Please use it to login.',
      }[root.$route.query.code]
    })
    return {
      message,
    }
  },
}
</script>
